function endpointDef(method, path) {
    return {
        method,
        path,
    };
}
export const feEndpoints = {
    defaultSounds: endpointDef("GET", "default-sounds"),
};
//# sourceMappingURL=fe-api.js.map